import type { Task } from '@/common/api/models/task';

/**
 * Essay tasks that still need a generated rubric.
 */
export const isEssayTaskWithoutRubric = (task: Task): boolean => {
  if (task.type !== 'essay') return false;
  const dimensions = task.rubric?.dimensions;
  return !dimensions || !Array.isArray(dimensions) || dimensions.length === 0;
};

export const getEligibleRubricGenerationTaskIds = (tasks: Task[] | undefined): string[] => {
  if (!tasks) return [];
  return tasks.filter(isEssayTaskWithoutRubric).map((task) => task.id);
};
